var _path, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    clipRule: "evenodd",
    d: "m11.467 10.534 3 3a.644.644 0 0 1 0 .933.72.72 0 0 1-.466.2.72.72 0 0 1-.467-.2l-3-3c-1 .734-2.2 1.2-3.533 1.2a5.662 5.662 0 0 1-5.667-5.666 5.662 5.662 0 0 1 5.667-5.667 5.662 5.662 0 0 1 5.666 5.667c0 1.333-.466 2.6-1.2 3.533zM7.001 2.667a4.325 4.325 0 0 0-4.334 4.334c0 2.4 1.934 4.333 4.334 4.333a4.28 4.28 0 0 0 3.066-1.267 4.28 4.28 0 0 0 1.267-3.066c0-2.4-1.933-4.334-4.333-4.334z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "6vipuzp4ga",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    clipRule: "evenodd",
    d: "m11.467 10.534 3 3a.644.644 0 0 1 0 .933.72.72 0 0 1-.466.2.72.72 0 0 1-.467-.2l-3-3c-1 .734-2.2 1.2-3.533 1.2a5.662 5.662 0 0 1-5.667-5.666 5.662 5.662 0 0 1 5.667-5.667 5.662 5.662 0 0 1 5.666 5.667c0 1.333-.466 2.6-1.2 3.533zM7.001 2.667a4.325 4.325 0 0 0-4.334 4.334c0 2.4 1.934 4.333 4.334 4.333a4.28 4.28 0 0 0 3.066-1.267 4.28 4.28 0 0 0 1.267-3.066c0-2.4-1.933-4.334-4.333-4.334z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1bd8333acf7a17cf00ca9690ffde3148.svg";
export { ForwardRef as ReactComponent };